class TabsDrawerComponent extends DrawerComponent {
  connectedCallback() {
    this.buildTabs();

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-tabs-panel-open]');
      if (!trigger) return;
      this.open(trigger);
      this.activateTab(trigger.dataset.tabsPanelOpen);
    });
  }

  buildTabs() {
    const items = document.querySelectorAll('.pdp-tabs-panel__content');
    if (!items.length) return;

    const nav = this.querySelector('.pdp-tabs-panel__nav');
    const body = this.querySelector('.pdp-tabs-panel__body');

    items.forEach((item) => {
      const tabId = item.id.replace('pdp-tab-', '');
      const label = item.dataset.tabLabel;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.id = `pdp-tabs-drawer-${tabId}-tab`;
      btn.className = 'pdp-tabs-nav__tab pdp-tabs-panel__tab title-xs';
      btn.dataset.tabId = tabId;
      btn.textContent = label;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', `pdp-tabs-drawer-${tabId}`);
      btn.setAttribute('aria-selected', 'false');
      btn.addEventListener('click', () => this.activateTab(tabId));
      nav.appendChild(btn);

      const pane = document.createElement('div');
      pane.id = `pdp-tabs-drawer-${tabId}`;
      pane.className = 'pdp-tabs-panel__pane';
      pane.dataset.paneId = tabId;
      pane.setAttribute('role', 'tabpanel');
      pane.setAttribute('aria-labelledby', `pdp-tabs-drawer-${tabId}-tab`);
      pane.setAttribute('hidden', '');
      pane.innerHTML = item.innerHTML;
      body.appendChild(pane);
    });

    this.indicator = document.createElement('span');
    this.indicator.className = 'pdp-tabs-nav__indicator';
    nav.appendChild(this.indicator);
  }

  activateTab(tabId) {
    this.querySelectorAll('.pdp-tabs-panel__tab').forEach((btn) => {
      btn.classList.toggle('pdp-tabs-nav__tab--active', btn.dataset.tabId === tabId);
      btn.setAttribute('aria-selected', btn.dataset.tabId === tabId);
    });
    this.querySelectorAll('.pdp-tabs-panel__pane').forEach((pane) => {
      pane.toggleAttribute('hidden', pane.dataset.paneId !== tabId);
    });

    const activeBtn = this.querySelector(`.pdp-tabs-panel__tab[data-tab-id="${tabId}"]`);
    if (activeBtn && this.indicator) {
      this.indicator.style.transform = `translateX(${activeBtn.offsetLeft}px)`;
      this.indicator.style.width = `${activeBtn.offsetWidth}px`;
    }
  }
}

customElements.define('tabs-drawer-component', TabsDrawerComponent);
